export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/edited_599c600ec698787ef631ef679c0eb911_21c4c2b9.jpg"
        alt="Bright modern Breakfast Republic restaurant interior with guests seated at the counter and coffee bar"
        title="JEDL Restaurants — Breakfast Republic"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/65" />

      <div className="relative z-10 w-full px-6 text-center max-w-4xl mx-auto pt-24 pb-20">
        <p className="text-[11px] md:text-xs uppercase tracking-[0.45em] text-background-50/80 mb-7">
          San Diego&nbsp;&bull;&nbsp;Restaurant Group
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-background-50 leading-[1.05] tracking-tight">
          Building Restaurants People Want to Come Back To.
        </h1>
        <p className="mt-7 text-base md:text-lg text-background-50/85 max-w-2xl mx-auto leading-relaxed">
          JEDL Restaurants is a San Diego-based restaurant group focused on creating, operating, and growing
          distinctive hospitality concepts.
        </p>

        <div className="mt-11 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#brands"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            Explore Our Brands
            <i className="ri-arrow-down-line text-base"></i>
          </a>
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-50/60 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors"
          >
            Work With Us
          </a>
        </div>
      </div>
    </section>
  );
}